import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '@/components/common/layout/auth';
import AuthCard from '@common/auth-card.jsx';
import { Typography, Input, Checkbox, Button, message } from 'antd';
import { SwapRightOutlined } from '@ant-design/icons';
import useAuthStore from '@store/useAuthStore';
import { t } from '@/utils/translator';

const { Title } = Typography;

function Home() {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [isClientLogin, setIsClientLogin] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      message.warning(t('이메일과 비밀번호를 입력하세요.'));
      return;
    }

    setLoading(true);
    const res = await login({
      email,
      password,
      type: isClientLogin ? 'client' : 'participant',
    });
    setLoading(false);

    if (res.success) {
      message.success(t('로그인에 성공했습니다.'));

      // 클라이언트 로그인 체크박스가 선택된 경우
      if (isClientLogin) {
        navigate('/client/dashboard');
      } else {
        // 일반 로그인인데 백엔드에서 type이 "client"인 경우 접근 제한
        if (res.user && res.user.type === 'client') {
          alert('접근 권한이 없습니다');
          return;
        }
        navigate('/projects');
      }
    } else {
      if (res.message === 'Not_Found_User') {
        message.error(t('가입하지 않은 이메일이거나 틀린 이메일 또는 비밀번호 입니다.'));
      } else {
        let errorMessage = t('유효하지 않은 로그인 형식입니다. \n');
        if (typeof res.message === 'string') {
          errorMessage = res.message;
        } else if (res.message?.[0]?.msg) {
          errorMessage += ` ${res.message[0].msg}`;
        }
        message.error(errorMessage);
      }
    }
  };

  return (
    <AuthLayout>
      <AuthCard>
        <div>
          <Title level={5} className="fw-medium mb-3">
            {t('로그인')}
          </Title>
          <div>
            <Input
              size="large"
              placeholder={t('이메일 (로그인 ID)')}
              className="mb-3"
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              type="password"
              size="large"
              placeholder={t('비밀번호')}
              className="mb-3"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleLogin();
                }
              }}
            />

            <Button
              loading={loading}
              className="text-center h-auto rounded-pill bg-dark text-white mb-3 p-2"
              // onClick={() => navigate('/projects')}
              onClick={handleLogin}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleLogin();
                }
              }}
              style={{ fontSize: '17px' }}
              block
            >
              {t('로그인')}
            </Button>
            <div className="d-flex align-items-center justify-content-end">
              <Link to="/reset_password">
                {t('비밀번호 찾기')} <SwapRightOutlined />
              </Link>
            </div>
          </div>
        </div>
      </AuthCard>
    </AuthLayout>
  );
}

export default Home;
